import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { PERSONALITIES } from "../data/site";
import { COLLECTIONS } from "../data/collections";
import CollectionGrid from "../components/CollectionGrid";
import { Squiggle } from "../components/Illustrations";
import Reveal from "../components/Reveal";

export default function Personality() {
  const { slug } = useParams();
  const p = PERSONALITIES.find((x) => x.slug === slug);
  const list = useMemo(() => COLLECTIONS.filter((c) => c.personality === slug), [slug]);
  const others = useMemo(() => PERSONALITIES.filter((x) => x.slug !== slug), [slug]);
  if (!p) {
    return (
      <div className="pt-40 text-center px-6" data-testid="personality-empty">
        <h1 className="font-serif text-4xl mb-4">Personality not found</h1>
        <Link to="/personalities" className="ink-link">Browse personalities →</Link>
      </div>
    );
  }

  return (
    <div className="pt-32" data-testid="personality-page">
      <section className="px-5 md:px-10">
        <div className="mx-auto max-w-[1280px] grid lg:grid-cols-12 gap-10 items-end pb-14 md:pb-20">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="eyebrow mb-4">Shop by personality</p>
            </Reveal>
            <Reveal delay={60}>
              <h1 className="font-serif text-5xl md:text-7xl lg:text-[112px] leading-[0.95] tracking-[-0.03em]">
                <span className="text-5xl md:text-6xl">{p.emoji}</span><br />
                {p.title}.
              </h1>
            </Reveal>
            <Reveal delay={140}>
              <p className="mt-7 text-xl md:text-2xl text-[#595955] leading-snug max-w-[36ch]">{p.line}</p>
            </Reveal>
            <Reveal delay={200}>
              <Squiggle w={140} className="mt-8 opacity-60" />
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal>
              <div className="aspect-[4/5] rounded-[28px] overflow-hidden bg-[#F3EADA] lift" data-hover="true">
                <img
                  src={`/products/${list[0]?.slug || 'sol'}-kid.jpg`}
                  alt={p.title}
                  className="w-full h-full object-cover"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <CollectionGrid items={list} title={`Frames for ${p.title.toLowerCase()}`} subtitle={`${list.length} curated frames in this personality.`} />

      {/* Browse other personalities */}
      <section className="px-5 md:px-10 pb-24">
        <div className="mx-auto max-w-[1280px]">
          <p className="eyebrow mb-5">Other personalities</p>
          <div className="flex flex-wrap gap-2">
            {others.map((x) => (
              <Link key={x.slug} to={`/personality/${x.slug}`} className="px-4 py-2 rounded-full bg-[#F3EADA] hover:bg-[#E8DCC4] transition-colors text-[14px]" data-testid={`other-personality-${x.slug}`}>
                {x.emoji} {x.title}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
